import React from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

export class ColorPicker extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
          displayColorPicker: false,
          color: {
              rgb: {
                  ...(props.color.rgb().object()),
                  a: props.color.alpha()
              }
          },
          tempColor: {
              rgb: {
                  ...(props.color.rgb().object()),
                  a: props.color.alpha()
              }
          }
      };
  }

  handleClick() {
      this.setState({ 
          ...this.state, 
          displayColorPicker: !this.state.displayColorPicker,
          tempColor: { ...this.state.color } 
      }, this.handleOnClose.bind(this))
  };

  handleClose() {
      this.setState({ ...this.state, displayColorPicker: false }, this.handleOnClose.bind(this));
  };

  handleOnClose() {
      this.props.onClose && !this.state.displayColorPicker && this.props.onClose(this.state.color);
  }

  handleChange(v) {
      if (this.props.onChange) {
          this.props.onChange(v);
      }
      this.setState({ ...this.state, tempColor: v });
  }  

  handleSave() {
      const newColor = { ...this.state.tempColor };
      this.setState({ ...this.state, color: newColor }, () => {
          if (this.props.onChangeComplete) {
              this.props.onChangeComplete(newColor);
          }
          this.handleClose();
      });
  }

  render() {

    const styles = reactCSS({
      'default': {
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: `rgba(${ this.state.color.rgb.r }, ${ this.state.color.rgb.g }, ${ this.state.color.rgb.b }, ${ this.state.color.rgb.a })`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
        saveButton: {
          background: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '0 0 4px 4px',
          padding: '6px 12px',
          fontSize: '12px',
          cursor: 'pointer',
          margin: '0',
          display: 'block',
          width: '100%',
          boxSizing: 'border-box',
        },
        pickerContainer: {
          boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 0px 1px, rgba(0, 0, 0, 0.15) 0px 8px 16px',
          borderRadius: '4px',
          overflow: 'hidden',
        }
      },
    });

    return (
      <div style={ this.props.style }>
        <div style={ styles.swatch } onClick={ this.handleClick.bind(this) }>
          <div style={ styles.color } />
        </div>
        { this.state.displayColorPicker ? <div style={ styles.popover }>
          <div style={ styles.cover } onClick={ this.handleClose.bind(this) }/>
          <div style={ styles.pickerContainer }>
            <SketchPicker 
              { ...(this.props) } 
              color={this.state.tempColor.rgb} 
              onChange={ this.handleChange.bind(this) } 
              onChangeComplete={null} 
            />
            <button 
              style={ styles.saveButton } 
              onClick={ this.handleSave.bind(this) }
            >
              Save
            </button>
          </div>
        </div> : null }

      </div>
    )
  }
}

